<template>
  <div :id="keyId">
    <div @click="openPanel" class="cursor-pointer">
      <slot
        name="header"
        :state="expandState"
        :show-icon="staticPanel"
        :openPanel="openPanel"
        :close="close"
      />
    </div>
    <div class="">
      <slot name="static" />
    </div>
    <TransitionExpand>
      <div v-show="expandState" class="px-2 py-4">
        <slot name="content" :close="close" :state="expandState" />
      </div>
    </TransitionExpand>
  </div>
</template>

<script setup>
import { onMounted, inject, ref, computed, watch, nextTick } from 'vue';
import { TransitionExpand } from '@morev/vue-transitions';
import isFunction from 'lodash/isFunction';
const props = defineProps({
  open: {
    type: [Boolean, String, Number],
    default: false,
  },
  staticPanel: {
    type: Boolean,
    default: false,
  },
  scrollToTop: {
    type: [Boolean, String, Number],
    default: false,
  },
});
const keyId = ref(null);
const toggleExpand = inject('toggleExpand');
const toggleState = inject('toggleState');

const expandState = computed(() => {
  return toggleState?.value?.includes(keyId.value);
});

const close = () => {
  if (isFunction(toggleExpand)) {
    toggleExpand(keyId.value);
  }
};
const openPanel = () => {
  if (props.staticPanel) return;
  if (isFunction(toggleExpand)) {
    toggleExpand(keyId.value);
  }
};

const uuidv4 = () => crypto.randomUUID();
watch(
  () => props.staticPanel,
  v => {
    if (isFunction(toggleExpand)) {
      toggleExpand(keyId.value);
    }
  },
  {
    immediate: false,
  }
);

const onScroll = () => {
  nextTick(() => {
    document.getElementById(keyId.value)?.scrollIntoView({ behavior: 'smooth' });
  });
};

onMounted(() => {
  keyId.value = uuidv4();
  if (props.open) {
    nextTick(() => {
      if (isFunction(toggleExpand)) {
        toggleExpand(keyId.value);
      }
    });
    if (props.scrollToTop) {
      nextTick(() => {
        onScroll();
      });
    }
  }
});
</script>
